<template>
    <hts-travel-details
        ref="travelRoute"
        :travel-details="travelDetails"
        :date-format="dateFormat"
        :travel-node-data-arr="travelNodeDataArr"
        :files="files"
        direction="horizontal"
        @clickStep="clickStep" />
</template>

<script setup lang="ts">
const emits = defineEmits(['modify', 'update-route', 'open-timing', 'open-planning'])
const travelRoute = ref<any>(null)
const props = defineProps({
  trip: {
    type: Object,
    required: true
  },
  travelDetails: {
    type: Array<any>,
    required: true
  },
  dateFormat: String,
  expanded: Boolean,
  files: {
    type: Array<any>
  }
})

const { trip, travelDetails, expanded } = toRefs(props)
const travelNodeDataArr = computed(() => trip.value?.travelNodeDataArr || [])

const clickStep = (value: any) => {}

watch(
  () => expanded.value,
  (val: boolean) => {
    toggleExpandCollapse(val)
  }
)

const toggleExpandCollapse = $lodash.debounce((val: boolean) => {
  if (!travelRoute.value) {
    return
  }
  travelRoute.value.toggleExpandCollapse(val)
}, 300)

defineExpose({})
</script>
